import { render, staticRenderFns } from "./PlayerCardStandings.vue?vue&type=template&id=6c344334&scoped=true&"
import script from "./PlayerCardStandings.vue?vue&type=script&lang=js&"
export * from "./PlayerCardStandings.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCardStandings.vue?vue&type=style&index=0&id=6c344334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c344334",
  null
  
)

export default component.exports